<div class="profile-content">
  <div class="row">
    <div class="col-md-12">
      <div class="caption caption-md">
        <span class="caption-subject">Preferences </span>
        <span class="caption-sub-subject test">Email preferences</span>
      </div>
    </div>

    <div class="form-group checkBoxAlienMent">
      <input
        class="chkOverview"
        type="checkbox"
        [(ngModel)]="isChecked"
        (change)="useEmailPreferences($event)"
      />
      <span class="notification-text">Do you want to receive email notifications?</span>
    </div>
  </div>
</div>
